/**
 * API para pantalla "Calificaciones Escolar" (Control Escolar)
 *
 * Endpoints sin restricción por asesor: cualquier usuario con acceso
 * al módulo Control Escolar puede ver TODOS los grupos del campus
 * y capturar calificaciones de cualquiera de ellos.
 *
 * IMPORTANTE: Para lectura de estudiantes/calificaciones reutiliza
 * `getEstudiantesGrupo` del módulo `calificaciones.js` (mismo endpoint
 * que la pantalla de Registro de Calificaciones).
 */

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

function getAuthToken() {
  return localStorage.getItem('authToken');
}

function getHeaders() {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
}

/**
 * Obtiene TODOS los grupos del campus seleccionado (sin filtro por asesor).
 * @param {Object} params
 * @param {number|string} [params.id_campus] - ID del campus (filtro global)
 * @param {number|string} [params.id_seccion] - ID de la sección académica (Lic./Prepa./Maestría/Doctorado)
 * @param {string} [params.search] - búsqueda por código de grupo o nombre de materia
 */
export async function getGruposCampus({ id_campus, id_seccion, id_ciclo_escolar, search } = {}) {
  try {
    const params = new URLSearchParams();
    if (id_campus !== undefined && id_campus !== null && id_campus !== '') {
      params.append('id_campus', id_campus);
    }
    if (id_seccion !== undefined && id_seccion !== null && id_seccion !== '') {
      params.append('id_seccion', id_seccion);
    }
    if (id_ciclo_escolar !== undefined && id_ciclo_escolar !== null && id_ciclo_escolar !== '') {
      params.append('id_ciclo_escolar', id_ciclo_escolar);
    }
    if (search) params.append('search', search);
    params.append('_t', Date.now());

    const url = `${API_BASE}/escolar/calificaciones/grupos-campus/?${params.toString()}`;
    const res = await fetch(url, { headers: getHeaders(), cache: 'no-store' });
    if (!res.ok) {
      console.error('[calificacionesEscolar] Error grupos-campus:', res.status);
      throw new Error('Error al obtener grupos del campus');
    }
    return await res.json();
  } catch (error) {
    console.error('[calificacionesEscolar] getGruposCampus error:', error);
    throw error;
  }
}

/**
 * Guarda/actualiza calificaciones de múltiples parciales en una sola petición.
 * UPSERT por (id_estudiante_grupo, tipo_evaluacion).
 *
 * @param {Object} data
 * @param {number} data.id_grupo
 * @param {Array}  data.calificaciones - [{ id_estudiante_grupo, parciales:{PARCIAL1,PARCIAL2,PARCIAL3,FINAL,EXTRAORDINARIO}, observaciones }]
 */
export async function guardarCalificacionesMulti(data) {
  try {
    const res = await fetch(`${API_BASE}/escolar/calificaciones/guardar-multi/`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data)
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      console.error('[calificacionesEscolar] Error guardar-multi:', res.status, errorData);
      throw new Error(errorData.error || 'Error al guardar calificaciones');
    }
    return await res.json();
  } catch (error) {
    console.error('[calificacionesEscolar] guardarCalificacionesMulti error:', error);
    throw error;
  }
}
